import React, { useEffect, useMemo, useState } from 'react';
import { Modal } from "react-bootstrap";
import Draggable from 'react-draggable';
import ModalHeader from '../../Setup/Shared/ModalHeader';
import SearchHeader from '../../Setup/Shared/SearchHeader';
import { useNavigate } from 'react-router-dom';
import NotificationHandler from '../../../utils/NotificationHandler';
import { connect, useDispatch } from 'react-redux';
import { enumUtil } from '../../../utils/Enum';
import { UserLogout } from '../../../actions/LoginAction';
import { useIdleTimer } from 'react-idle-timer';
import { createPortal } from 'react-dom';
import UserTimeout from '../../Login/UserTimeout';

const UserActivityChecker = (props) => {
  const { Settings } = { ...props }
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const timePopupLimit = Settings.TimeOut ? Settings.TimeOut * 60 : 1800 // in seconds
  const timeWarningLimit = Settings.TimeOutWarning ? Settings.TimeOutWarning * 60 : 300 // in seconds

  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [remainingTime, setRemainingTime] = useState(timeWarningLimit);
  const [isUserTimeout, setIsUserTimeout] = useState(false)
  const [isTokenValid, setIsTokenValid] = useState(true)
  const {
    getRemainingTime,
    isIdle,
    reset
  } = useIdleTimer({
    timeout: timePopupLimit * 1000,
    promptTimeout: timeWarningLimit * 1000,
    debounce: 250,
    onPrompt: () => { setIsOpenPopup(true); },
    onIdle: () => { handleLogout(); },
    onActive: () => { setIsOpenPopup(false); },
  });

  const handleLogout = () => {
    // navigate("../usertimeout", { replace: true });
    if (!isUserTimeout) {
      // console.log("handleLogout")
      setIsUserTimeout(true);
      // NotificationHandler("Session has expired", enumUtil.enumtoaster.error);
    }
    // dispatch(UserLogout());
  };

  const handleContinue = () => {
    reset();
    setIsOpenPopup(false);
  };

  const handleResume = (is_Token_Valid) => {
    reset();
    setIsUserTimeout(false);
    setIsTokenValid(is_Token_Valid);
  };

  const proceedHeader = () => {
    return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '12px' }}>Session Timeout</p>;
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setRemainingTime(getRemainingTime());
    }, 1000);

    return () => clearInterval(timer);
  }, [getRemainingTime]);

  useEffect(() => {
    const timeoutScreen = document.querySelector('#root .usertime_out');

    if (isUserTimeout) {
      // console.log("isUserTimeoutisUserTimeout")
      if (timeoutScreen) {
        // console.log("isUserTimeouttimeoutScreen")
        timeoutScreen.setAttribute("aria-hidden", "false"); // Ensure it's visible to assistive tech
        document.body.classList.add('timeout-active');
      }
    } else {
      // console.log("isUserTimeoutNottimeoutScreen")
      if (!isTokenValid) {
        navigate("../", { replace: true })
        dispatch(UserLogout());
      }
      document.body.classList.remove('timeout-active');
      if (timeoutScreen) {
        // timeoutScreen.setAttribute("aria-hidden", "true"); // Hide when session resumes
      }
    }
  }, [isUserTimeout]);
  return (
    <div>
      {(isIdle && !isUserTimeout) && (
        <Modal
          show={isOpenPopup}
          onHide={() => setIsOpenPopup(false)}
          backdrop="static"
          keyboard={false}
          centered
          dialogClassName="ar-session_time_modal za-discard-changes hk-modal-v1"
        >
          <Draggable handle=".modal-body">
            <Modal.Body>
              <SearchHeader masterListButton={isOpenPopup} />
              {/* <ModalHeader HeaderName={proceedHeader} DeletePopup={""} key={999} Name={'SessionTimeout'} /> */}
              <div className="d-flex justify-content-between align-items-center mb-12 px-10">
                <p className="heading fs-14 dark-clr">Session Expire Warning</p>
                <i className="icon-x-cros fs-20 fs-20 dark-clr" onClick={handleContinue}></i>
              </div>
              <div className="px-10 mb-12 ">
                <div className='ar-alert d-flex  gap-6 w-100 mb-0'>
                  <i className='icon-alert fs-16 mt-0-5'></i>
                  <p className='text'>Due to inactivity your session will expire in <span className="heading">{Math.floor(remainingTime / 1000 / 60)} min {Math.floor(remainingTime / 1000 % 60)} secs.</span> Do you want to continue the session?</p>
                </div>
              </div>
              <div className="modal_footer za_br_light br-top-1 pt-2 ">
                <div className='za-button text-end d-flex justify-content-end gap-2'>
                  {/* <button className='btn btn-outline fs-12 px-10 rounded drk_clr' onClick={() => {navigate("../", { replace: true });dispatch(UserLogout());}}>Logout</button> */}
                  <button className='btn btn-danger fs-12 px-10 rounded' onClick={handleContinue}>Continue</button>
                </div>
              </div>
            </Modal.Body>
          </Draggable>
        </Modal>
      )
      }

      {
        isUserTimeout && createPortal(
          <UserTimeout handleResume={handleResume} />,
          document.getElementById("root") // Attach to portal root
        )
      }
    </div >
  );
};

const mapStateToProps = (state) => {
  return {
    Settings: state.SettingsReducer,
  }
}
export default connect(mapStateToProps)(UserActivityChecker);
